module.exports = {"TXTWCL_Search":{"id":"TXTWCL_Search","defaultMessage":"Sök"}}